module.exports = __webpack_public_path__ + "media/images/companyPage/personal_excellence-79b50b562cb26a70e214cf20f99c3090.svg";